// client/src/components/common/NotFound.js
import React from 'react';
import { useTranslation } from 'react-i18next'; // Import
import './NotFound.css';

function NotFound() {
  const {t} = useTranslation();
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>{t('NotFound.errors.notFound')}</p> {/* Use i18next */}
    </div>
  );
}

export default NotFound;